import axios, { AxiosInstance } from 'axios'

declare const window: Window & typeof globalThis & {
    _globalParams?: {
        location: {
            hostname: string
            port: string
        }
    }
}

const instance = () => {
    const location = {
        hostname: window?.location?.hostname ?? '127.0.0.1',
        port: window?.location?.port ?? 8043
    }

    return axios.create({
        baseURL: `//${location.hostname}:${location.port}`,
        timeout: 10000,
    });
}

export class Config {
    req: AxiosInstance = instance()
}